import Form from "../../../base/forms/form";
import ServiceLocator from "../../../../global/service-locator";

export default class FormPage {
	constructor($root, mainController) {
		/* Elements */
		this.$root = $root;

		this.sl = ServiceLocator.instance;

		/* Components */
		this.mainController = mainController;
		this.shouldUpdateHeight = false;

		/* Config */
		this.data = null;
	}

	init(switchPageCallback) {
		FormPage.prototype.switchPage = switchPageCallback;

		setTimeout(() => {
			this.shouldUpdateHeight = true;
		}, 300);

		this.data = this.mainController.getResult();
		this.setForm();
	}

	setForm() {
		this.mainController.form = new Form({
			formId: 'special-event-quiz',
			uri: '/1.0/promo/quiz',
			shouldClose: false,
			data: {
				fbp: costorage.get('_fbp') ? costorage.get('_fbp') : null,
				fbc: costorage.get('_fbc') ? costorage.get('_fbc') : null,
				referrer: location.href,
				type: 'quiz',
				ratio: this.data.ratio,
				answers: this.data.questionList
			},
			subscriptions: [
				{
					event: 'beforeSubmit',
					callback: ({ detail }) => {
						this.userData = Object.assign({}, detail);
					}
				},
				{
					event: 'submitComplete',
					callback: () => {
						this.mainController.finishQuiz(this.userData);
						this.switchPage();
						this.shouldUpdateHeight = false;
					}
				},
				{
					field: 'getConsultation',
					event: 'timeSelectToggleVisibility',
					callback: ({ detail }) => {
						if (this.shouldUpdateHeight) {
							this.mainController.animation.updateHeight(null, false);
						}
					}
				}
			]
		});
	}
}